import { BaseStatusCode } from '@store/orders';

export const mapCodesToMenuItems = (codes: BaseStatusCode[]) => {
  return codes.map((item) => ({
    label: `${item.code} ${item.description}`,
    value: item.code,
    category: item.category,
  }));
};
